export const tubeSectionContent = {
  kicker: "The Bigger Picture & Data Foundation",
  heading: "Embedded intelligence starts with connected data flow",
  description:
    'This "Tube Map" is shown as the main visual to represent a continuous information path between all areas of MWH Treatment.',
  hint: "Select a marker to explore each stage.",
};

const tubeHotspots = [
 {
    id: "asset-creation",
    label: "Asset Creation",
    title: "Orientate around assets",
    detail:
      "Delivering projects with an asset-first mindset.\nOptimising whole-life value, performance and resilience.\nAligning design, delivery and operation around asset outcomes.\nCreating a continuous digital thread across the asset lifecycle.",
    x: 25.85,
    y: 46,
  },
  {
    id: "asset-integration",
    label: "Asset Integration",
    title: "Bring established assets into projects",
    detail:
      "Start with the asset, not a blank project.\nReuse approved asset definitions, data and governance from day one.\nAlign project activities to operational asset requirements.\nDeliver consistent outcomes across the asset lifecycle.",
    x: 33.9,
    y: 46,
  },
  {
    id: "data-integration",
    label: "Data Integration",
    title: "Asset-centric by design",
    detail:
      "Bringing together all data, workflows and insights around what matters most.\nCreating a single, connected view of every asset throughout its lifecycle.\nEnabling better decisions through complete asset context and traceability.",
    x: 48.45,
    y: 46,
  },
  // {
  //   id: "operational-insights-a",
  //   label: "Operational Insights",
  //   title: "Live Operational Context",
  //   detail:
  //     "Expose status and risk signals in context so teams can make faster, better decisions on site.",
  //   x: 10.5,
  //   y: 7.5,
  //   size: "small",
  // },
  // {
  //   id: "operational-insights-b",
  //   label: "Operational Insights",
  //   title: "Live Operational Context",
  //   detail:
  //     "Expose status and risk signals in context so teams can make faster, better decisions on site.",
  //   x: 21.9,
  //   y: 7.5,
  //   size: "small",
  // },
];

export default tubeHotspots;
